import { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import {
  SearchBar,
  HorizontalLine,
  Button,
  Contact,
  SearchIcon,
  useClickOutSide,
  getHighlightedText,
} from '@trufla-technology/trumarket-react-design-system';
import { startCase } from 'lodash';
import { useListUsers } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import './style.scss';
import { TabPathsType, useGetTabPath } from 'app/hooks/useGetTabPath';

export type SearchObject = {
  searchValue: string;
};

export const TopLevelSearch = () => {
  const [searchValue, setSearchValue] = useState<string>();
  const searchRef = useRef<HTMLDivElement>(null);
  const { show: clickedOutside, setShow: setClickedOutside } = useClickOutSide(
    true,
    searchRef,
  );
  const { data, handleFilter, loading } = useListUsers({
    paginate: { offset: 0, limit: 10 },
    sort: [
      {
        sortBy: 'fullName',
        sortOrder: 'asc',
      },
    ],
  });
  const history = useHistory();
  const getTabPath = useGetTabPath();

  const handleSearch = (searchValue: string): void => {
    setSearchValue(searchValue);
    setClickedOutside(true);
  };
  useEffect(() => {
    if (!searchValue) return;
    const timeout = setTimeout(
      () => handleFilter({ fullName: searchValue }),
      600,
    );
    return () => clearTimeout(timeout);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  return (
    <div className="top-level-search">
      <SearchBar
        placeholder="Search For User"
        onSearch={handleSearch}
        icon={<SearchIcon fill="#54616C" />}
        value={searchValue || ''}
      >
        {clickedOutside
          ? !!data && (
              <div ref={searchRef} className="options-dropdown">
                {loading ? (
                  <div className="tru-loader-container">
                    <span className="loader" />
                    <span>searching</span>
                  </div>
                ) : data.length ? (
                  <>
                    <h4>All</h4>
                    <HorizontalLine verticalMargin="-1px" />

                    {data.map(({ key, fullName, email, active }) => (
                      <div
                        key={key}
                        className="search-contact-wrapper"
                        onClick={() => {
                          getTabPath(
                            history.location.pathname
                              .split('/')
                              .pop() as TabPathsType,
                            key!,
                          );
                          setSearchValue('');
                        }}
                      >
                        <Contact
                          name={startCase(fullName!)}
                          highLightedName={getHighlightedText(
                            startCase(fullName!),
                            searchValue!,
                          )}
                          email={email!}
                          link={
                            <Button
                              type="link"
                              onClick={() => {
                                getTabPath(
                                  history.location.pathname
                                    .split('/')
                                    .pop() as TabPathsType,
                                  key!,
                                );
                                setSearchValue('');
                              }}
                            >
                              {active ? 'Active' : 'Inactive'}
                            </Button>
                          }
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>No data found</>
                )}
              </div>
            )
          : null}
      </SearchBar>
    </div>
  );
};
